// extracted by mini-css-extract-plugin
export default {"imagesWrapper":"YF-z"};